import { IconButton, IconButtonProps, styled } from '@mui/material';

import { X } from '@/shared/components/icons';

const CloseButton = styled((props: IconButtonProps) => {
  return (
    <IconButton size='small' {...props}>
      <X fontSize='small' />
    </IconButton>
  );
})(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1.2),
  right: theme.spacing(1.2),
}));

export default CloseButton;
